import { Component, OnInit } from '@angular/core';
import { tap } from 'rxjs/operators';
import { V6attributeService } from 'src/app/core/services/v6attribute.service';
import { V6FrameConfigMode } from '../../../../../../../core/enums';
import { FrameTemplate, IFrameTemplate, IProductTemplate, ProductTemplate } from '../../../../../../../core/models';
import { MacroService } from '../../../../../../../core/services/macro.service';
import { V6productService } from '../../../../../../../core/services/v6product.service';

@Component({
  selector: 'app-configure-frame',
  templateUrl: './configure-frame.component.html',
  styleUrls: ['./configure-frame.component.scss']
})
export class ConfigureFrameComponent implements OnInit {

  productModel: IProductTemplate;
  frameInEditMode: IFrameTemplate;
  currentFrameConfigMode: V6FrameConfigMode;
  attributeList: any[];
  selectedAttributeName: string;
  nestedFrameIndexInEditMode: number;
  formTitle: string = '';
  otherNestedFrameIndex: number[] = [];
  sourceFrameIndex: number;

  constructor(private v6prdService: V6productService,
    private v6attrService: V6attributeService) {
    this.productModel = this.v6prdService.productModel;
    this.currentFrameConfigMode = this.v6prdService.frameConfigMode;
    this.nestedFrameIndexInEditMode = this.v6prdService.nestedFrameIndexInEditMode;
   

  }

 
  ngOnInit() {
    this.otherNestedFrameIndex = [];
    const nestFrameCount = this.productModel.nestedFrames.length;
    this.attributeList = this.v6attrService.getAttributes();
    switch (this.currentFrameConfigMode) {
      case V6FrameConfigMode.ADD_NESTED_FRAME:
        this.formTitle = 'Add Nested Frame';
        for (let i = 0; i < nestFrameCount; i++) {
          if (i !== this.nestedFrameIndexInEditMode) {
            this.otherNestedFrameIndex.push(i + 1);
          }
        }
        this.frameInEditMode = new FrameTemplate();
        break;
      case V6FrameConfigMode.EDIT_NESTED_FRAME:
        this.formTitle = 'Edit Nested Frame';
        for (let i = 0; i < nestFrameCount; i++) {
          if (i !== this.nestedFrameIndexInEditMode) {
            this.otherNestedFrameIndex.push(i + 1);
          }
        }
        this.frameInEditMode = this.productModel.nestedFrames[this.nestedFrameIndexInEditMode];
        break;
      case V6FrameConfigMode.ADD_RESOURCE_FRAME:
        this.formTitle = 'Add Resource Frame';
        this.frameInEditMode = new FrameTemplate();
        break;
      case V6FrameConfigMode.EDIT_RESOURCE_FRAME:
        this.formTitle = 'Edit Resource Frame';
        this.frameInEditMode = this.productModel.resourceFrame;
        break;
      default:
        this.frameInEditMode = new FrameTemplate();
        break;
    }
    //this.memberPropertyInit();
  }

  get v6AttributeService() {
    return this.v6attrService;
  }
  //#region Events
  attributeFilterChangeHandler(value) {
   
    this.attributeList = this.v6attrService.attributeFilterChangeHandler(value);
  }
  //#endregion

 


  saveFrame() {
    const finalFrameConfig = Object.assign({}, this.frameInEditMode);
    switch (this.currentFrameConfigMode) {
      case V6FrameConfigMode.ADD_NESTED_FRAME:
        this.productModel.nestedFrames.push(finalFrameConfig);
        break;
      case V6FrameConfigMode.EDIT_NESTED_FRAME:
        this.productModel.nestedFrames[this.nestedFrameIndexInEditMode] = finalFrameConfig;
        break;
      case V6FrameConfigMode.ADD_RESOURCE_FRAME:
      case V6FrameConfigMode.EDIT_RESOURCE_FRAME:
        this.productModel.resourceFrame = finalFrameConfig;
        break;
      default: break;
    }
  }

  copyFrameSettings() {
    const f = this.productModel.nestedFrames[this.sourceFrameIndex - 1];//length verification
    this.frameInEditMode = Object.assign({}, f);
  }
  //#region Navigation 
  goBack(index: number) {
    this.v6prdService.configFormIndex = 2;
  }
  //#endregion

  //#region Frame Attributes
  addFrameAttribute() {
    if (this.selectedAttributeName) {
      const attribute = this.attributeList.find(x => x.name === this.selectedAttributeName);
      //check if already present in the attribute list
      const doesExist = this.frameInEditMode.attributeFilters.find(x => x.name === attribute.name) ? true : false;
      if (!doesExist) {
        this.frameInEditMode.attributeFilters.push(Object.assign({},attribute));
      }
    }
    this.selectedAttributeName = '';
  }
  removeFrameAttribute(attributeIndex) {
    if (this.frameInEditMode.attributeFilters.length > attributeIndex) {
      (this.frameInEditMode.attributeFilters as []).splice(attributeIndex, 1);
    }
  }
  //#endregion

  frameSelectionChanged(flag:boolean) {
    this.frameInEditMode.haveFrameCode = flag;
  }
}
